@if (items().length > 0) {
<section class="staff-birthdays-banner" [attr.aria-label]="titleKey() | translate">
  <h2 class="staff-birthdays-banner__title">{{ titleKey() | translate }}</h2>
  <ul class="staff-birthdays-banner__list">
    @for (item of items(); track item.user.id) {
    <li
      class="staff-birthdays-banner__item"
      [class.staff-birthdays-banner__item--today]="item.days_offset === 0"
    >
      <a class="staff-birthdays-banner__profile-link" [routerLink]="detailLink(item)">
        <span class="staff-birthdays-banner__name">{{ formatName(item) }}</span>
        <span class="staff-birthdays-banner__offset">{{ offsetLabel(item.days_offset) }}</span>
      </a>
      @if (item.user.phone) {
      <a class="staff-birthdays-banner__phone" [href]="'tel:' + item.user.phone">
        {{ item.user.phone }}
      </a>
      }
    </li>
    }
  </ul>
</section>
}
